(function() {
  function initFlexibleColumnsSection(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.bsgFlexibleColumnsInitialized === 'true') return;
    if (sectionRoot.querySelector('[data-bsg-flexible-tabs], [data-bsg-flexible-dropdown]')) return;
    sectionRoot.dataset.bsgFlexibleColumnsInitialized = 'true';

  const slider = sectionRoot.querySelector('.flexible-columns-slider');
  const sliderControls = sectionRoot.querySelector('[data-gf-slider-controls]');
  const sliderDots = Array.from(sectionRoot.querySelectorAll('[data-gf-slider-dot]'));
  let sliderFrame = null;
  let pageCount = 1;
  const prevButton = sectionRoot.querySelector('button[name="previous"]');
  const nextButton = sectionRoot.querySelector('button[name="next"]');
  const sectionId = sectionRoot.id ? sectionRoot.id.replace(/^shopify-section-/, '') : '';
  const popupOverlay = sectionId ? document.getElementById('GFPopupOverlay-' + sectionId) : null;
  const popupModal = popupOverlay ? popupOverlay.querySelector('.gf-popup-modal') : null;
  const popupContent = sectionId ? document.getElementById('GFPopupContent-' + sectionId) : null;
  const popupCloseButton = popupOverlay ? popupOverlay.querySelector('[data-popup-close]') : null;
  const popupTriggers = sectionRoot.querySelectorAll('.gf-popup-trigger');
  const alignedFieldKeys = [
    'above-eyebrow',
    'eyebrow',
    'heading',
    'text',
    'subtext',
    'price',
    'html',
    'liquid',
    'cta',
    'below-cta'
  ];
  let normalizeTimer = null;
  function getPopupPayload(payloadId) {
    if (!payloadId) return null;

    const payloadScript = document.getElementById(payloadId);
    if (!payloadScript) return null;

    try {
      return JSON.parse(payloadScript.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function setPopupArticleStyleState(enabled) {
    if (!popupOverlay || !popupModal || !popupContent) return;

    const isArticleStyle = enabled === true;
    popupOverlay.classList.toggle('is-article-style', isArticleStyle);
    popupModal.classList.toggle('is-article-style', isArticleStyle);
    popupContent.classList.toggle('is-article-style', isArticleStyle);
  }

  function closePopupModal() {
    if (!popupOverlay || !popupContent) return;

    setPopupArticleStyleState(false);
    popupOverlay.style.display = 'none';
    popupContent.innerHTML = '';
    popupOverlay.setAttribute('aria-hidden', 'true');
  }

  function openPopupModal(payload) {
    if (!popupOverlay || !popupContent || !payload) return;

    const hasLinks = Array.isArray(payload.links) && payload.links.length;
    const hasImages = Array.isArray(payload.images) && payload.images.length;
    const hasContent = payload.html || payload.header || payload.body || hasLinks || hasImages;
    const isArticleStyle = payload.articleStyle === true;

    if (!hasContent) return;
    setPopupArticleStyleState(isArticleStyle);

    if (payload.html) {
      popupContent.innerHTML = isArticleStyle
        ? '<article class="gf-popup-article">' + payload.html + '</article>'
        : payload.html;
      popupOverlay.style.display = 'block';
      popupOverlay.setAttribute('aria-hidden', 'false');
      return;
    }

    let imagesHtml = '';
    if (hasImages) {
      const imageCount = payload.images.length;
      const imageRowClass = 'gf-popup-image-row' + (payload.imagesRounded ? ' is-rounded' : '');
      imagesHtml = '<div class="' + imageRowClass + '" data-count="' + imageCount + '">' +
        payload.images.map(function(image) {
          return '<img src="' + image.src + '" alt="' + (image.alt || '') + '">';
        }).join('') +
      '</div>';
    }

    let linksHtml = '';
    if (hasLinks) {
      const inlineLinks = payload.linksInline !== false;
      const builtLinks = payload.links.map(function(link) {
        return '<a href="' + link.href + '" class="alerting-link">' +
          '<span class="alerting-link-text">' + link.label + '</span>' +
          '<span class="arrow">❯</span>' +
        '</a>';
      });

      linksHtml = inlineLinks
        ? '<p>' + builtLinks.join(' | ') + '</p>'
        : builtLinks.map(function(linkHtml) { return '<p>' + linkHtml + '</p>'; }).join('');
    }

    const bodyHtml = payload.body
      ? (payload.body.indexOf('<') === -1 ? '<p>' + payload.body + '</p>' : payload.body)
      : '';

    let popupMarkup =
      (payload.header ? '<p><strong>' + payload.header + '</strong></p>' : '') +
      imagesHtml +
      bodyHtml +
      linksHtml;

    if (isArticleStyle) {
      popupMarkup = '<article class="gf-popup-article">' + popupMarkup + '</article>';
    }

    popupContent.innerHTML = popupMarkup;

    popupOverlay.style.display = 'block';
    popupOverlay.setAttribute('aria-hidden', 'false');
  }

  if (popupOverlay && popupCloseButton) {
    setPopupArticleStyleState(false);
    popupOverlay.setAttribute('aria-hidden', 'true');

    popupTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(event) {
        event.preventDefault();
        const payloadId = trigger.getAttribute('data-popup-payload-id');
        const payload = getPopupPayload(payloadId);
        openPopupModal(payload);
      });
    });

    popupOverlay.addEventListener('click', function() {
      closePopupModal();
    });

    popupCloseButton.addEventListener('click', function(event) {
      event.preventDefault();
      closePopupModal();
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && popupOverlay.style.display === 'block') {
        closePopupModal();
      }
    });
  }

  function getSlideStep() {
    const items = slider ? slider.querySelectorAll('.slider-item') : [];
    if (items.length > 1) return Math.max(1, items[1].offsetLeft - items[0].offsetLeft);
    return items.length ? items[0].offsetWidth || 1 : 1;
  }

  function getActiveSlide() {
    return Math.min(pageCount - 1, Math.max(0, Math.round(slider.scrollLeft / getSlideStep())));
  }

  function updateSliderControls() {
    if (!slider) return;
    const maxScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
    const count = slider.querySelectorAll('.slider-item').length;
    pageCount = Math.max(1, Math.min(count, Math.ceil(maxScroll / getSlideStep()) + 1));
    const active = getActiveSlide();
    if (sliderControls) sliderControls.hidden = !window.matchMedia('(max-width: 767px)').matches || maxScroll <= 2;
    sliderDots.forEach(function(dot, index) {
      dot.hidden = index >= pageCount;
      dot.classList.toggle('is-active', index === active);
      if (index === active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
    if (prevButton) prevButton.disabled = active === 0;
    if (nextButton) nextButton.disabled = active >= pageCount - 1 || slider.scrollLeft >= maxScroll - 2;
  }

  function queueSliderControlsUpdate() {
    if (sliderFrame !== null) return;
    sliderFrame = window.requestAnimationFrame(function() {
      sliderFrame = null;
      updateSliderControls();
    });
  }

  function scrollToSlide(index) {
    updateSliderControls();
    const target = Math.min(pageCount - 1, Math.max(0, index));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    slider.scrollTo({ left: Math.min(Math.max(0, slider.scrollWidth - slider.clientWidth), target * getSlideStep()), behavior: reducedMotion ? 'auto' : 'smooth' });
  }

  function getVisibleCards(container) {
    return Array.from(container.querySelectorAll('.gf-align-card')).filter(function(card) {
      return card.getClientRects().length > 0;
    });
  }

  function groupCardsByTop(cards) {
    const rows = [];
    const tolerance = 4;

    cards.forEach(function(card) {
      const top = Math.round(card.getBoundingClientRect().top);
      let row = null;

      for (let i = 0; i < rows.length; i += 1) {
        if (Math.abs(rows[i].top - top) <= tolerance) {
          row = rows[i];
          break;
        }
      }

      if (!row) {
        row = { top: top, cards: [] };
        rows.push(row);
      }

      row.cards.push(card);
    });

    return rows;
  }

  function normalizeFieldHeightsInCards(cards) {
    alignedFieldKeys.forEach(function(fieldKey) {
      const selector = '.gf-field--' + fieldKey;
      const fields = cards.map(function(card) {
        return card.querySelector(selector);
      }).filter(Boolean);

      if (!fields.length) return;

      fields.forEach(function(field) {
        field.style.minHeight = '';
      });

      let maxHeight = 0;
      fields.forEach(function(field) {
        if (field.offsetHeight > maxHeight) {
          maxHeight = field.offsetHeight;
        }
      });

      if (maxHeight > 0) {
        fields.forEach(function(field) {
          field.style.minHeight = maxHeight + 'px';
        });
      }
    });
  }

  function normalizeFlexibleColumnRows() {
    const containers = sectionRoot.querySelectorAll('.flexible-columns-grid, .flexible-columns-slider');

    containers.forEach(function(container) {
      container.querySelectorAll('.gf-field').forEach(function(field) {
        field.style.minHeight = '';
      });

      const cards = getVisibleCards(container);
      if (!cards.length) return;

      const rows = groupCardsByTop(cards);
      rows.forEach(function(row) {
        normalizeFieldHeightsInCards(row.cards);
      });
    });
  }

  function queueNormalizeFlexibleColumnRows() {
    window.clearTimeout(normalizeTimer);
    normalizeTimer = window.setTimeout(normalizeFlexibleColumnRows, 90);
  }

  if (slider) {
    if (prevButton) prevButton.addEventListener('click', function() { scrollToSlide(getActiveSlide() - 1); });
    if (nextButton) nextButton.addEventListener('click', function() { scrollToSlide(getActiveSlide() + 1); });
    sliderDots.forEach(function(dot, index) { dot.addEventListener('click', function() { scrollToSlide(index); }); });
    slider.addEventListener('scroll', queueSliderControlsUpdate, { passive: true });
    if ('ResizeObserver' in window) {
      const sliderObserver = new ResizeObserver(queueSliderControlsUpdate);
      sliderObserver.observe(slider);
      const onUnload = function(event) {
        if (event.target !== sectionRoot) return;
        sliderObserver.disconnect();
        if (sliderFrame !== null) window.cancelAnimationFrame(sliderFrame);
        window.removeEventListener('resize', queueSliderControlsUpdate);
        window.removeEventListener('load', queueSliderControlsUpdate);
        document.removeEventListener('shopify:section:unload', onUnload);
      };
      document.addEventListener('shopify:section:unload', onUnload);
    }
    queueSliderControlsUpdate();
  }

  // Lazy autoplay videos when visible
  const lazyVideos = sectionRoot.querySelectorAll('video.lazy-autoplay-video');
  if (lazyVideos.length && 'IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        const video = entry.target;
        if (!video) return;

        if (entry.isIntersecting) {
          try {
            video.play();
          } catch (e) {}
        } else {
          try {
            video.pause();
          } catch (e) {}
        }
      });
    }, {
      root: null,
      rootMargin: '200px 0px',
      threshold: 0.25
    });

    lazyVideos.forEach(function(video) {
      videoObserver.observe(video);
    });
  }

  sectionRoot.querySelectorAll('img').forEach(function(image) {
    image.addEventListener('load', queueNormalizeFlexibleColumnRows, { passive: true });
  });

  sectionRoot.querySelectorAll('video').forEach(function(video) {
    video.addEventListener('loadedmetadata', queueNormalizeFlexibleColumnRows, { passive: true });
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(queueNormalizeFlexibleColumnRows).catch(function() {});
  }

  window.addEventListener('load', queueNormalizeFlexibleColumnRows);
  window.addEventListener('load', queueSliderControlsUpdate);
  window.addEventListener('resize', queueNormalizeFlexibleColumnRows);
  window.addEventListener('resize', queueSliderControlsUpdate);
  queueNormalizeFlexibleColumnRows();
  queueSliderControlsUpdate();
  }

  function initAllFlexibleColumnsSections(root) {
    const scope = root || document;
    if (scope.matches && scope.matches('.shopify-section') && scope.querySelector('.gf-flexible-columns')) {
      initFlexibleColumnsSection(scope);
    }

    scope.querySelectorAll('.shopify-section').forEach(function(sectionRoot) {
      if (sectionRoot.querySelector('.gf-flexible-columns')) {
        initFlexibleColumnsSection(sectionRoot);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAllFlexibleColumnsSections(document);
    });
  } else {
    initAllFlexibleColumnsSections(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAllFlexibleColumnsSections(event.target);
  });
})();
